import { render, staticRenderFns } from "./RewardsOverviewCard.vue?vue&type=template&id=0aafe659"
import script from "./RewardsOverviewCard.vue?vue&type=script&lang=js"
export * from "./RewardsOverviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports